import createStore from './store';

export type EditorCapability =
  // Clip level
  | 'clip-publish'
  | 'clip-download'
  | 'clip-create'
  | 'clip-undo-redo'
  | 'clip-save-template'
  | 'audio-mixer'
  // Timeline
  | 'timeline-trim'
  | 'timeline-cut'
  | 'timeline-segment-dnd'
  | 'timeline-scene-edit'
  | 'timeline-scene-add'
  | 'timeline-transition-edit'
  | 'timeline-hook-add'
  | 'timeline-intro-outro-edit'
  | 'timeline-chapters-edit'
  | 'timeline-track-delete'
  // Overlay elements (canvas-level interactions)
  | 'element-dnd'
  | 'element-popover'
  | 'element-zoom-effect'
  | 'element-customizer'
  // Customizer sidebar panels (each independently disableable)
  | 'customizer-templates'
  | 'customizer-layout'
  | 'customizer-captions'
  | 'customizer-background'
  | 'customizer-images'
  | 'customizer-videos'
  | 'customizer-overlays'
  | 'customizer-audio'
  | 'customizer-versioning'
  // Transcript
  | 'transcript-edit'
  | 'transcript-download';

export const EDITOR_RESTRICTION_REASONS = {
  VERSION_VIEW: 'version-view'
} as const;

interface EditorRestrictionsState {
  restrictions: Record<string, EditorCapability[]>;
}

const initialState: EditorRestrictionsState = {
  restrictions: {}
};

const store = createStore<EditorRestrictionsState>(initialState);

export const editorRestrictionsStore = {
  ...store,
  setRestrictions: (reason: string, capabilities: EditorCapability[]) =>
    store.update(draft => {
      draft.restrictions[reason] = capabilities;
    }),
  clearRestrictions: (reason: string) =>
    store.update(draft => {
      delete draft.restrictions[reason];
    })
};
